import React, { useContext } from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppContext } from "../../App";
import { useUser } from "../../UserContext";
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SyncIcon from '@mui/icons-material/Sync';
import DescriptionIcon from '@mui/icons-material/Description';

export default function Invoices() {
  const navigate = useNavigate();
  const { userRecord } = useContext(AppContext);
  const { activeProvider } = useUser();

  const getRelativeLink = (path) => {
    // Return direct paths without company prefix
    return path;
  };

  return (
    <Box sx={{ 
      backgroundColor: '#000',
      minHeight: '100vh',
      padding: '20px',
    }}>
      {/* Title */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}>
        <DescriptionIcon sx={{ color: '#24e4ff', fontSize: 48, mr: 2 }} />
        <Typography 
          variant="h2" 
          sx={{ 
            color: '#24e4ff',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          INVOICES
        </Typography>
      </Box>

      {/* Green Line */}
      <Box 
        sx={{ 
          height: '2px',
          backgroundColor: '#24e4ff',
          margin: '20px 0 40px 0',
        }} 
      />

      {/* Description */}
      <Typography 
        sx={{ 
          color: '#fff',
          textAlign: 'center',
          marginBottom: '30px',
          maxWidth: '600px',
          margin: '0 auto 30px auto',
        }}
      >
        Manage invoices you send to your customers and receive from your suppliers. 
        Create new invoices, track payments, and maintain your business relationships.
      </Typography>

      {/* Button Stack */}
      <Stack 
        spacing={3} 
        sx={{ 
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        <Button
          startIcon={<AddIcon sx={{ fontSize: 30 }} />}
          sx={{
            backgroundColor: '#24e4ff',
            color: '#000',
            borderRadius: '20px',
            padding: '20px',
            fontSize: '24px',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#35d33d',
            },
          }}
          onClick={() => navigate(getRelativeLink('/create-invoice'))}
        >
          Create Invoice
        </Button>

        <Button
          startIcon={<VisibilityIcon sx={{ fontSize: 30 }} />}
          sx={{
            backgroundColor: '#24e4ff',
            color: '#000',
            borderRadius: '20px',
            padding: '20px',
            fontSize: '24px',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#35d33d',
            },
          }}
          onClick={() => navigate(getRelativeLink('/view-invoices'))}
        >
          View Invoices
        </Button>

        <Button
          startIcon={<SyncIcon sx={{ fontSize: 30 }} />}
          disabled={true}
          sx={{
            backgroundColor: '#24e4ff',
            color: '#000',
            borderRadius: '20px',
            padding: '20px',
            fontSize: '24px',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#35d33d',
            },
            '&.Mui-disabled': {
              backgroundColor: '#2a9e30',
              color: 'rgba(0, 0, 0, 0.5)',
            }
          }}
          onClick={() => navigate(getRelativeLink('/sync-backup'))}
        >
          Sync Backup
        </Button>
      </Stack>
    </Box>
  );
}
